
export const columns = (utilizaValorCustoProcedimento)=>[
  {
    Header: "Nome",
    align: "left",
    getValue: (data) => {
      return data.nomePaciente;
    },
  },
  {
    Header: "Data",
    align: "left",
    getValue: (data) => {
      return data.dataAtendimento
    },
  },
  {
    Header: "Profissional",
    align: "left",
    getValue: (data) => {
      return data.profissionalResponsavelNome;
    },
  },
  {
    Header: "Convenio",
    align: "left",
    getValue: (data) => {
      return data.convenio;
    },

  },
  ...(utilizaValorCustoProcedimento
    ? [
      {
        Header: "Valor de Custo",
        align: "left",
        getValue: (data) => data.valorCusto || 0,
        field: "valorCusto",
      },
    ]
    : []),
  {
    Header: "Procedimento",
    align: "left",
    getValue: (data) => {
      return data.procedimento;
    },
    field: "procedimento",
  },

];

